export const swatches = (cols, fn, attribs = {}) => ["g", attribs, ...cols.map(fn)];
export const swatchesH = (cols, w = 5, h = 50, attribs) => swatches(cols, (fill, i) => ["rect", { fill }, [i * w, 0], w, h], attribs);
export const swatchesV = (cols, w = 50, h = 5, attribs = {}) => swatches(cols, (fill, i) => ["rect", { fill }, [0, i * h], w, h], attribs);
